import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import Spinner from "@components/Spinner/Spinner";
import ServerError from "@components/Error/ServerError";
import Breadcrumb from "@components/Breadcrumb/Breadcrumb";
import { ViewTypeButton } from "@modules/Projects/pages/ProjectDetail/Button";
import { getAllTrees } from "@modules/Trees/services/treeCrud";
import ProjectMapView from "@modules/Projects/components/ProjectMapView";

export default function WithoutProjectMapView() {
  const { t } = useTranslation();
  const [trees, setTrees] = useState([]);

  // Fetch all trees
  const {
    data: allTrees,
    isLoading,
    isError,
  } = useQuery("trees-without-project-map", getAllTrees, {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  useEffect(() => {
    if (!allTrees) return;

    // Filter trees that have no project_id or project_id is null
    const treesWithoutProject = allTrees
      .filter((tree) => !tree.project_id)
      .map((tree) => ({
        ...tree,
        area: tree.area_name || t("without_location"),
        areaId: tree.area_id || null,
      }));

    setTrees(treesWithoutProject);
  }, [allTrees, t]);

  if (isLoading) return <Spinner height={"70vh"} />;
  if (isError) return <ServerError />;

  // Create a pseudo-project object for the map view
  const pseudoProject = {
    id: "without-project",
    name: t("without_project"),
    trees: trees,
    areas: [],
  };

  return (
    <>
      <Breadcrumb title={t("without_project")} viewType={<ViewTypeButton id="without-project" />} />
      <ProjectMapView project={pseudoProject} trees={trees} />
    </>
  );
}
